var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carouselExampleIndicators",
      "data-ride": "carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner"
  }, [_c('div', {
    staticClass: "carousel-item active"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": require("./Home-pics/change-1.jpg"),
      "alt": "Friends Forever"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption",
    attrs: {
      "id": "first-caption"
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("FRIENDS")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Making A Better Society")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/about'
      },
      "exact": ""
    }
  }, [_vm._v("Discover More")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "d-block w-100",
    attrs: {
      "src": require("./Home-pics/change-2.jpg"),
      "alt": "Children in Slums"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption",
    attrs: {
      "id": "second-caption"
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("UPSC")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Currently running Urban Primary Health Centers")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/projects'
      },
      "exact": ""
    }
  }, [_vm._v("Get More details")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    staticClass: "w-100 d-block",
    attrs: {
      "src": require("./Home-pics/doc-kid-closeup-2.jpg"),
      "alt": "Special Health Camps"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption",
    attrs: {
      "id": "third-caption"
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("CAMPS")]), _vm._v(" "), _c('p', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("To improve health of poors in urban slums")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-md btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        path: '/events#specialCamps'
      },
      "exact": ""
    }
  }, [_vm._v("View our gallery")])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#carouselExampleIndicators",
      "data-slide-to": "2"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63e093ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Carousel.vue
// module id = Oc/I
// module chunks = 0